import { removeCookie } from '../cookies/removeCookie.js';
import { storage } from '../storage/storage.js';
import { getConsentFor } from './getConsentFor.js';
import { onConsentChange } from './onConsentChange.js';
import { vendorStorageIds, deprecatedVendorStorageIds } from './vendorStorageIds.js';
const removeData = ({ cookies = [], localStorage = [], sessionStorage = [] }) => {
    for (const name of cookies) {
        removeCookie({ name });
    }
    for (const name of localStorage) {
        storage.local.remove(name);
    }
    for (const name of sessionStorage) {
        storage.session.remove(name);
    }
};
const removeUnconsentedData = (consent) => {
    Object.keys(vendorStorageIds).forEach((vendor) => {
        const consentForVendor = getConsentFor(vendor, consent);
        const vendorData = vendorStorageIds[vendor];
        if (!consentForVendor) {
            removeData(vendorData);
        }
    });
    Object.entries(deprecatedVendorStorageIds).forEach(([, vendorData]) => removeData(vendorData));
};
const initVendorDataManager = () => {
    onConsentChange((consent) => {
        if ("requestIdleCallback" in window) {
            requestIdleCallback(() => {
                removeUnconsentedData(consent);
            }, {
                timeout: 2e3
            });
        }
        else {
            removeUnconsentedData(consent);
        }
    });
};
export { initVendorDataManager };
